import type React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/context'

interface ProtectedRouteProps {
	children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
	const { user } = useAuth()
	const location = useLocation()

	if (!user) {
		// Redirect to login page with the return url
		return <Navigate to="/login" state={{ from: location }} replace />
	}

	// Check if onboarding is required
	if (!user.onboarding_completed && location.pathname !== '/onboarding') {
		return <Navigate to="/onboarding" replace />
	}

	// Gate access if terms are not accepted after onboarding completion
	if (
		user.onboarding_completed &&
		!user.accepted_terms_and_conditions &&
		location.pathname !== '/accept-terms'
	) {
		return <Navigate to="/accept-terms" state={{ from: location }} replace />
	}

	return <>{children}</>
}
